import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=789c2739&scoped=true&"
import script from "./Modules.vue?vue&type=script&lang=js&"
export * from "./Modules.vue?vue&type=script&lang=js&"
import style0 from "./Modules.vue?vue&type=style&index=0&id=789c2739&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c2739",
  null
  
)

export default component.exports